<template>
  <div>
    <div v-if="getCodeForRun != null">{{ runCode() }}</div>
    <div v-if="getCodeInputData.step == 3">{{ sendStdIntoKernel() }}</div>

    <v-card
      outlined
      :class="[
        'app-page-card border-radius-lg mt-4 mb-3',
        currentRouteName === 'chapter_content' ? '' : 'mx-2',
      ]"
    >
      <v-card-text>
        <v-layout row wrap>
          <v-flex xs2>
            <v-icon title="Run all codes on page">fast_forward</v-icon>
            <v-icon
              title="Delete results of codes"
              @click="$store.commit('setCodeDeleteResults', true)"
              >delete_sweep</v-icon
            >
          </v-flex>
          <v-flex xs4>
            <small>kernel status: {{ kernel_status }}</small>
          </v-flex>
          <v-flex xs6>
            <div style="text-align: right">
              Kernel:
              <v-icon title="Interrupt kernel" @click="resetKernel('interrupt')"
                >cancel</v-icon
              >
              <v-icon title="Restart kernel" @click="resetKernel('restart')"
                >autorenew</v-icon
              >
              <v-icon title="Delete kernel" @click="resetKernel('delete')"
                >delete_forever</v-icon
              >
            </div>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import config from "../../config.js";
import axios from "../../axios-auth";

export default {
  data() {
    return {
      myExecutionSocket: null,
      kernel: null,
      token: "",
      kernel_status: "",
      myconfig: {
        headers: { "Content-Type": "text/plain" },
        "Access-Control-Allow-Origin": "*",
      },
      last_activity: 0,
    };
  },
  props: {
    id: Number,
    format: String,
    my_element: String,
    my_elementA: Array,
    objectChangePermission: Boolean,
  },
  computed: {
    ...mapGetters(["getCodeForRun", "getCodeInputData"]),
    currentRouteName() {
      return this.$route.name;
    },
  },
  mounted() {
    // this.initData()
    this.initKernelAndToken();
  },
  beforeDestroy() {
    if (this.myExecutionSocket != null) {
      this.myExecutionSocket.close();
    }
  },
  unmount() {
    if (this.myExecutionSocket != null) {
      this.myExecutionSocket.close();
    }
  },
  methods: {
    initKernelAndToken() {
      this.kernel = this.$store.getters.getCodeForRunKernel;
      axios
        .get("/get-jupy-token", this.$store.getters.getAxiosConfig)
        .then((res) => {
          this.token = res.data.jupytoken;
        })
        .catch((error) => {
          this.$store.commit("setFeedback", error);
        });
    },
    resetKernel(_type) {
      if (this.kernel == null) return;
      this.kernel_status = "waiting";
      this.kernel_status = _type + "ed";
      this.$store.commit("setCodeKernelReset", true);
      this.myExecutionSocket.close();
      this.myExecutionSocket = null;

      if (_type == "delete") {
        axios.delete(
          config.baseKernelGatewayURL +
            "/api/kernels/" +
            this.kernel.id +
            "?token=" +
            this.token,
          {},
          this.myconfig
        );
        this.kernel = null;
        this.$store.commit("setCodeForRunKernel", null);
      } else {
        axios
          .post(
            config.baseKernelGatewayURL +
              "/api/kernels/" +
              this.kernel.id +
              "/" +
              _type +
              "?token=" +
              this.token,
            {},
            this.myconfig
          )
          .then(() => {
            this.writeKernelActivity(this.kernel.id);
          })
          .catch((error) => {
            this.$store.commit("setFeedback", error);
          });
      }
    },
    runCode() {
      const _code = this.getCodeForRun;
      this.$store.commit("setCodeForRun", null);
      // exists kernel?
      if (this.kernel) {
        // is alive?
        axios
          .get(
            config.baseKernelGatewayURL +
              "/api/kernels/" +
              this.kernel.id +
              "?token=" +
              this.token,
            this.myconfig
          )
          .then((res) => {
            console.log(res.data);
            this.kernel = res.data;
            this.kernel_status = "kernel alive... " + this.kernel.id;
            this.prepareExecutionSocket(_code);
          })
          .catch(() => {
            // console.log(error.message)
            this.createKernelAndSocket(_code);
            // this.$store.commit('setFeedback', error)
          });
      } else {
        this.createKernelAndSocket(_code);
      }
    },
    createKernelAndSocket(_code) {
      axios
        .post(
          config.baseKernelGatewayURL + "/api/kernels?token=" + this.token,
          {},
          this.myconfig
        )
        .then((res) => {
          this.kernel = res.data; //.kernel
          console.log("new kernel");
          console.log(this.kernel);
          this.$store.commit("setCodeForRunKernel", this.kernel);
          this.writeKernelActivity(this.kernel.id);
          this.kernel_status = "kernel created... " + this.kernel.id;
          this.prepareExecutionSocket(_code);
        })
        .catch((error) => {
          this.$store.commit("setFeedback", error);
        });
    },
    prepareExecutionSocket(_code) {
      if (
        this.myExecutionSocket == null ||
        this.myExecutionSocket.readyState == 3
      ) {
        const _address =
          config.baseKernelGatewayWS +
          "/api/kernels/" +
          this.kernel.id +
          "/channels?session_id=" +
          this.$store.getters.user.user_id +
          "&token=" +
          this.token;
        this.myExecutionSocket = new WebSocket(_address);

        this.myExecutionSocket.onopen = () => {
          this.kernel_status = "socket connected... ";
          this.myExecutionSocket.send(
            JSON.stringify(
              this.prepareExecutionMessage(_code, "execute_request")
            )
          );
        };
        this.myExecutionSocket.onerror = (e) => {
          this.kernel_status = "socket error... ";
          console.log(e);
          if (e.currentTarget == null) this.createKernelAndSocket(_code);
        };
        this.myExecutionSocket.onmessage = (data) => {
          this.processExecutionData(data);
        };
        this.myExecutionSocket.onclose = () => {
          console.log("socket closed...");
          this.kernel_status = "socket closed... ";
        };
      } else {
        this.myExecutionSocket.send(
          JSON.stringify(this.prepareExecutionMessage(_code, "execute_request"))
        );
      }
    },
    prepareExecutionMessage(_data, _msgType) {
      this.writeKernelActivity(this.kernel.id);
      const _msgID =
        "" + Date.now() + _data.execution_count + "_" + _data.index;
      const x = {
        header: {
          username: "user_" + this.$store.getters.user.user_id, //"",
          version: "5.3",
          msg_id: _msgID,
          msg_type: _msgType,
        },
        parent_header: {},
        channel: "shell",
        content: {
          code: _data.code,
          silent: false,
          store_history: false,
          user_expressions: {},
          allow_stdin: true,
          stop_on_error: false,
          store_history: true,
          disposeOnDone: false,
        },
        metadata: {},
        buffers: {},
      };
      return x;
    },
    processExecutionData(_data) {
      // if python works too long without user activity
      if (Math.floor((new Date() - this.last_activity) / 1000) > 300)
        this.writeKernelActivity(this.kernel.id);
      const cur = JSON.parse(_data.data);
      var _result = { outputs: [] };
      const _type = cur.channel;
      const _index = parseInt(
        cur.parent_header.msg_id.substring(
          cur.parent_header.msg_id.indexOf("_") + 1
        )
      );
      this.kernel_status =
        cur.header.msg_type + "/" + cur.content.execution_state;
      switch (_type) {
        case "iopub":
          const _msgType = cur.header.msg_type;

          switch (_msgType) {
            case "stream":
              _result.outputs = cur.content.text;
              this.$store.commit("setCodeForRunAnswer", {
                result: _result,
                index: _index,
                atype: "text",
              });
              break;
            case "error":
              _result.outputs = cur.content.ename + "\n" + cur.content.evalue;
              this.$store.commit("setCodeForRunAnswer", {
                result: _result,
                index: _index,
                atype: "text",
              });
              break;
            case "display_data":
              _result.outputs = cur.content.data["image/png"];
              this.$store.commit("setCodeForRunAnswer", {
                result: _result,
                index: _index,
                atype: "png",
                width: this.getImageWidth(cur.content.data["text/plain"]),
              });
              // console.log(cur.content.data['text/plain'])
              break;
            case "execute_result":
              if (cur.content.data["text/plain"].contains("Image")) {
                _result.outputs = cur.content.data["image/png"];
                this.$store.commit("setCodeForRunAnswer", {
                  result: _result,
                  index: _index,
                  atype: "png",
                  width: 500,
                });
                // console.log(cur.content.data['text/plain'])
              }
              break;
          }
          break;
        case "stdin": // console.log('send')
          this.$store.commit("setCodeInputData", {
            step: 1,
            parentHeader: cur.header,
            inputText: cur.content.prompt,
            data: "",
            index: _index,
          });
          // https://jupyter-client.readthedocs.io/en/latest/messaging.html#stdin-messages
          // https://jupyter-server.readthedocs.io/en/latest/developers/rest-api.html
          break;
        case "shell":
          switch (cur.header.msg_type) {
            case "execute_reply": // console.log('execution done')
              this.myExecutionSocket.close();
              break;
          }
          break;
      }
      // console.log(cur)
    },
    sendStdIntoKernel() {
      this.$store.commit("setCodeInputData", {
        step: 0,
        parentHeader: this.getCodeInputData.parentHeader,
        inputText: "",
        data: this.getCodeInputData.data,
        index: this.getCodeInputData.index,
      });
      const _msgID = "" + Date.now() + "_" + this.getCodeInputData.index;
      const _data = {
        header: {
          username: "user_" + this.$store.getters.user.user_id, //"",
          version: "5.3",
          msg_id: _msgID,
          msg_type: "input_reply",
        },
        parent_header: this.getCodeInputData.parentHeader,
        channel: "stdin",
        content: {
          value: this.getCodeInputData.data,
        },
        metadata: {},
        buffers: {},
      };
      this.myExecutionSocket.send(JSON.stringify(_data));
    },
    writeKernelActivity(_id) {
      this.last_activity = Date();
      const _data = {
        kernel_id: _id,
      };
      axios
        .post("/write-kernel-use", _data, this.$store.getters.getAxiosConfig)
        .then((res) => {
          if (res.data.message != "OK")
            this.$store.commit("setFeedback", res.data.message);
        })
        .catch((error) => {
          this.$store.commit("setFeedback", error);
        });
    },
    getImageWidth(_text) {
      let _index = _text.indexOf("size ");
      let _x = _text.indexOf("x", _index);
      return parseInt(_text.substring(_index + 5, _x));
    },
  },
};
</script>
